export { default } from "./DeleteUser";



// WEBPACK FOOTER //
// ./src/mutations/DeleteUser/index.ts